import { render, staticRenderFns } from "./MediaDetailPage.vue?vue&type=template&id=027059f4&"
import script from "./MediaDetailPage.vue?vue&type=script&lang=js&"
export * from "./MediaDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./MediaDetailPage.vue?vue&type=style&index=0&id=027059f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports